import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../../common.service";
import { ApiService } from "../../api.service";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: 'app-learning-camp-report',
  templateUrl: './learning-camp-report.component.html',
  styleUrls: ['./learning-camp-report.component.css']
})
export class LearningCampReportComponent implements OnInit, AfterViewInit {
  @Input() onceValue: any;
  @Input() campName: string;
  @Input() report: any;
  @Output() onCloseLearningCampReport = new EventEmitter<any>();

  isClosePage: boolean = false; //是否关闭页面
  assetsRoute: string = "../../../assets"; //静态资源地址
  isShowCommonBtn: boolean = false;
  userName: string;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private apiService: ApiService,
              private cookieService: CookieService,
              private commonService: CommonService) {}

  ngOnInit() {
    this.userName = localStorage.getItem('userName');
    this.commonService.getOnceIno(this.onceValue).then(result=>{
      this.isShowCommonBtn = result === 1 ? false : true;
    })
  }

  ngAfterViewInit() {
    setTimeout(()=>{
      this.savePic();
    },500);
  }

  //H5转png
  savePic(){
    let dom = document.getElementById('user-certificate');
    // let width = dom.scrollWidth;
    // let height = dom.scrollHeight;
    let width = dom.offsetWidth;
    let height = dom.offsetHeight;

    let scale = this.setDPR();
    let y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    let cs = document.createElement('canvas');
    cs.width = width * scale;
    cs.height = height * scale;
    cs.style.width =  cs.width / 50+'rem';
    cs.style.height = cs.height / 50+'rem';
    let ctx = cs.getContext('2d');
    ctx.scale(scale, scale);

    $(dom).scrollTop(0,y);

    html2canvas(dom,{
      dpi: 300,
      backgroundColor: '#FFFFFE',
      canvas: cs,
      scale: scale/scale,
      useCORS: true,
      allowTaint: true,
      taintTest: false,
      width: width,
      height: height
    }).then((canvas)=>{
      let context = canvas.getContext('2d');
      context.mozImageSmoothingEnabled = false;
      context.webkitImageSmoothingEnabled = false;
      context.msImageSmoothingEnabled = false;
      context.imageSmoothingEnabled = false;
      $('#user-certificate-img').attr('src',canvas.toDataURL("image/png", 1.0));
    }).then(()=>{
      $('#user-certificate').hide();
      this.commonService.initPage({
        'backgroundColor': '#F2F3FA'
      });
    });
  }


  //根据window.devicePixelRatio获取像素比
  setDPR(){
    return window.devicePixelRatio && window.devicePixelRatio > 1 ? window.devicePixelRatio : 1;
  }


  //毕业生称号注解
  reportAchievementExplain(level){
    return {1:'结业证书',2:'毕业证书',3:'优秀毕业证书'}[level]||"荣誉毕业生";
  }

  //报告等级注解
  reportLevelExplain(level){
    return {1:'薄弱',2:'有限',3:'一般',4:'良好',5:'优秀',6:'卓越'}[level]||'良好';
  }

  //关闭学习旅程
  closeLearningCampReport(){
    this.isClosePage = true;
    this.commonService.setOnceIno(this.onceValue).subscribe(()=>{
      setTimeout(()=>{
        this.onCloseLearningCampReport.emit();
      },300);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-report/learning-camp-report.component.ts